"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TimeSeries_1 = __importDefault(require("./TimeSeries"));
const Category_1 = __importDefault(require("./Category"));
class CategoryTimeSeriesData {
    constructor({ label, values, category }) {
        this.toJSON = () => ({
            label: this.label,
            values: this.values,
            category: this.category,
        });
        this.label = label;
        this.values = values;
        this.category = category;
    }
}
CategoryTimeSeriesData.fromJSON = (json) => {
    const { label, values, category } = Object.assign({}, json);
    if (typeof label !== 'string')
        throw new Error('.label must be a string');
    if (!Array.isArray(values))
        throw new Error('.values must be an array');
    const _values = values.map(item => TimeSeries_1.default.fromJSON(item));
    const _category = Category_1.default.fromJSON(category);
    return new CategoryTimeSeriesData({
        label,
        values: _values,
        category: _category,
    });
};
exports.default = CategoryTimeSeriesData;
